define((require) => {
    "use strict";

    const _ = require("underscore");

    /**
     * Mixes in product action related functionality across different generic product widgets, ensuring
     * that all product related actions behave as uniformly as possible.
     *
     * @class ProductActionMixin
     * @constructor
     */
    return {

        defaults: {
            productIdParameter: null // mixed in with super Action defaults
        },

        // TODO: uncomment "_event" for proper support for PRODUCT_VIEW events across different implementations, uncommented
        //       to comply with current (bad) behaviour where the implementation type defines the event triggered instead
        //       on focusing on actual data sent! When doing so, remember to update ViewerAnalyticsManager PRODUCT_VIEW
        //       listener! When doing so, also require "productId()" to return an actual product!

        // Even though implemented as various implementations, the semantics is to view a product...
        // _event: ViewerEvents.PRODUCT_VIEW,

        /**
         * Returns the parameter name used to identify the product id for this Action, if any.
         *
         * @return {String} The name of the parameter used to identity the product id; can be falsey if not set or
         *                  if it does not match a declared parameter.
         */
        productIdParameter() {
            // Because of current issues with stat tracking, allow the "productIdParameter" to be unspecified...
            const name = this.get("productIdParameter");
            if (name) {
                // If specified, make sure it is a valid parameter name...
                const parameters = this.get("parameters");
                if (parameters && parameters[name]) {
                    return name;
                }
            }
            return null;
        },

        /**
         * Returns the product id for this Action, deduced from the aptly named parameter value. <p>
         *
         * The product id found is the product id that will be tracked for the <tt>PRODUCT_VIEW</tt> event on
         * successful activation.
         *
         * @return {String} The product id; can be falsey if not set, which will current <b>not</b> prevent
         *                  activation; this should be the case, but not so until product related stats have
         *                  been implemented correctly.
         */
        productId() {
            // If we get a name back here, we know it is declared as a parameter, but the value may still be falsey...
            const name = this.productIdParameter();
            return (name && this.get("parameters")[name]) || null;
        },

        _activateable() {
            // For now, allow a missing product id until we get proper product action stats...
            const productId = this.productId();
            if (!productId) {
                this._log("Missing product id", "info");
                // Fall-through
            }
            // Call super validation, which can still fail...
            return this.__super();
        },

        _activate() {
            // Do the actual activation by calling the super implementation. At this point, we know we have a product
            // id to track as this is ensured in _activateable. The super implementation, e.g. ProductLinkAction
            // -> LinkAction, will return additional argument(s) to include, e.g. {url: "actual/url", target: "actual_target"},
            // so we store those on the returned event args as well. The super arguments are currently what is tracked
            // via external stats (see TODO above)...
            const superEventArgs = this.__super();

            return _.extend(superEventArgs || {}, {type: "generic", context: this.constructor.TYPE, productId: this.productId()});
        }

    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/product/ProductActionMixin.js